var Users = $.extend(false, BaseModule ,{

    api_route: 'users',

    data: {
        module      : 'users',
        page        : 1,
        limit       : 20,
        order_by    : 'id:desc',
        view        : 'list'
    },

    load_list_dialog: function(selectionMarkup, selection_name, selection_container, t, cb) {
        var module_name = this.data.module;
        var b = $('body');

        var title = t || module_name.toUpperCase();
        if ($('#users-dialog-list').length === 0) {
            b.append('<div id="users-dialog-list" class="vertical-menu" style="z-index:9999;padding:0;right: 0;width:750px; background: #fff; overflow-y: auto;overflow-x: hidden;">\
                <div class="clearfix p-3 bg-dark"><h4 class="text-white modal-title float-left ">'+title+'</h4>\
                <button type="button" class="btn btn-dark float-right" onclick="$(\'#users-dialog-list\').remove();" aria-hidden="true" class="btn btn-icon">Close <i class=\'bx bx-x\'></i></button></div>\
                <div class="modal-body" style="padding:0;">\
                </div></div>');
        }

        $("#users-dialog-list .modal-body").data('sm', selectionMarkup);
        $("#users-dialog-list .modal-body").data('selectionname',selection_name);
        $("#users-dialog-list .modal-body").data('selectioncontainer',selection_container);
        $("#users-dialog-list .modal-body").data('cb', cb);
        $("#users-dialog-list .modal-body").html('<div class="users-form"></div>' +
            '<div class="row">' +
            '<div class="col">' +
            '<div class="users-list list-container" data-target="'+module_name+'"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
            '<div class="details-container" data-target="'+module_name+'"></div>'+
            '</div>' +
            '<div class="col-lg-3 col-xl-2 d-none" >' +
            '<div class="'+module_name+'-filters"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
            '</div>' +
            '</div>');

        Users.load_userList({ display_view:'popup' });
    },

    load_managerList_dialog:function(selectionMarkup, selection_name, selection_container) {
        var module_name = 'users';
        var body = $('body');
        
        if ($('#manager-dialog-list').length === 0) {
            body.append('<div id="manager-dialog-list" class="vertical-menu" style="z-index:9999;padding:0;right: 0;width:750px; background: #fff; overflow-y: auto;overflow-x: hidden;">\
                <div class="clearfix p-3 bg-dark"><h4 class="text-white modal-title float-left">SELECT A MANAGER</h4>\
                <button type="button" class="btn btn-dark float-right" onclick="$(\'#manager-dialog-list\').remove();" aria-hidden="true" class="btn btn-icon">Close <i class=\'bx bx-x\'></i></button></div>\
                <div class="modal-body" style="padding:0;">\
                </div></div>');
        }

        $("#manager-dialog-list .modal-body").data('sm', selectionMarkup);
        $("#manager-dialog-list .modal-body").data('selectionname', selection_name);
        $("#manager-dialog-list .modal-body").data('selectioncontainer', selection_container);
        $("#manager-dialog-list .modal-body").html('<div class="manager-form"></div>' +
            '<div class="row">' +
            '<div class="col">' +
            '<div class="manager-list list-container" data-target="'+module_name+'"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
            '<div class="details-container" data-target="'+module_name+'"></div>'+
            '</div>' +
            '<div class="col-lg-3 col-xl-2 d-none">' +
            '<div class="manager-filters"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
            '</div>' +
            '</div>');

        Users.load_managerList({ display_view:'popup' });
    },
    
    load_userList : function(objectt) {
        "use strict";
        
        var module = this,
            module_name = module.data.module,
            request_data = $.extend({}, module.last_request_data, {intent:'load-list'}, objectt, module.data),
            filter_data = $('#users-dialog-list').find('.filters[data-module="'+module_name+'"]').serializeArray();
            
        if (typeof(objectt) !=='undefined' && typeof(objectt.view) !== 'undefined') {
            request_data.view = objectt.view;
        }

        $('.global-progress').remove();
        $('body').prepend('<div class="global-progress progress" style="z-index: 9999; position: fixed; top: 0; right: 0; width: 100%;"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div>')

        var filter_data_values=[];
        for(var i in filter_data) {
             var name = filter_data[i].name,  value = filter_data[i].value;
            if(value === ''){
                if(typeof( request_data[name.replace('[]','')]) !=='undefined' ){
                    delete request_data[name.replace('[]','')];
                }
            }else{
                if (name.indexOf('[]') != -1) {
                    if (typeof(filter_data_values[name.replace('[]','')]) == 'undefined') {
                        filter_data_values[name.replace('[]','')] = [];
                    }

                    filter_data_values[name.replace('[]','')].push(value); 
                }
                else {
                    filter_data_values[name] = value;    
                }
            }
        }

        for (var i in filter_data_values) {
             var name = i,  value = filter_data_values[i];
               request_data[name] = value;
        }

        var $list_container = $('#users-dialog-list').find('.list-container[data-target="'+module_name+'"]');
        
        $('#users-dialog-list').find('.page-header[data-target="'+module_name+'"]').show();
        $('#users-dialog-list').find('.' + module_name + '-filters').show();
        $('#users-dialog-list').find('.details-container[data-target="'+module_name+'"]').hide();
        
        module.last_request_data = request_data;

        $list_container.off('item-selected');
        
        $.ajax({
            url : API + module.api_route,
            data:request_data,
            error: function() {
                $('.global-progress').remove();
                delete module.data['no-cache'];
                $('#users-dialog-list').find('.list-container[data-target="'+module_name+'"]').html('<div class="alert alert-danger">Ooops...something went wrong</div>');
            },
            success: function(data) {
                $('.global-progress').remove();
                $('#users-dialog-list').find('.'+module_name+'-filters').replaceWith(data.filters);
                $('#users-dialog-list').find('.'+module_name+'-filters').show();

                var $items = $(data.markup);
                $items.find('img').on('error',module.onImageError);
                $list_container.html($items);
                                
                var checked = [];
                $('.related-users-list input[name="'+module_name+'[]"]').each(function() {
                    checked.push($(this).val());
                });

                $list_container.find('input.selectable-item:checkbox').each(function(){
                    var id = $(this).val();
                    $(this).attr('checked', checked.indexOf(id) != -1);
                });

                $list_container.find('input.selectable-item:checkbox').on('change',function(){
                    var checked = $(this).is(":checked"), 
                        caller = $(this).closest('.list-container[data-target="'+module_name+'"]'),
                        all_data = $(this).data();
                        
                    setTimeout(function(){
                        caller.trigger('item-selected', [all_data, checked]);
                    }, 10);
                });
                
                initForm('#users-dialog-list .list-container[data-target="'+module_name+'"]');
                initForm('#users-dialog-list .filters-form');

                Users.after_load_userList();
            }
        });
    },

    load_managerList: function(objectt) {
        "use strict";
        
        var module = this,
            module_name = module.data.module,
            request_data = $.extend({}, module.last_request_data, {intent:'load-list'}, objectt, module.data),
            filter_data = $('#manager-dialog-list').find('.filters[data-module="'+module_name+'"]').serializeArray();
            
        if (typeof(objectt) !=='undefined' && typeof(objectt.view) !=='undefined') {
            request_data.view = objectt.view;
        }

        $('.global-progress').remove();
        $('body').prepend('<div class="global-progress progress" style="z-index: 9999; position: fixed; top: 0; right: 0; width: 100%;"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div>')

        var filter_data_values = [];
        for (var i in filter_data) {
            var name = filter_data[i].name,  value = filter_data[i].value;

            if (value === '') {
                if (typeof(request_data[name.replace('[]', '')]) !=='undefined') {
                    delete request_data[name.replace('[]', '')];
                }
            }
            else {
                if (name.indexOf('[]') != -1) {
                    if (typeof(filter_data_values[name.replace('[]','')]) == 'undefined') {
                        filter_data_values[name.replace('[]','')] = [];
                    }

                    filter_data_values[name.replace('[]','')].push(value); 
                }
                else {
                    filter_data_values[name] = value;    
                }
            }
        }

        for (var i in filter_data_values) {
            var name = i,  value = filter_data_values[i];
            request_data[name] = value;
        }
        
        var $list_container = $('#manager-dialog-list').find('.list-container[data-target="'+module_name+'"]');
        
        $('#manager-dialog-list').find('.page-header[data-target="'+module_name+'"]').show();
        $('#manager-dialog-list').find('.' + module_name + '-filters').show();
        $('#manager-dialog-list').find('.details-container[data-target="'+module_name+'"]').hide();
        
        module.last_request_data = request_data;

        $list_container.off('item-selected');
        
        $.ajax({
            url : API + module.api_route,
            data: request_data,
            error: function() {
                $('.global-progress').remove();
                delete module.data['no-cache'];
                $('#manager-dialog-list').find('.list-container[data-target="'+module_name+'"]')
                    .html('<div class="alert alert-danger">Ooops...something went wrong</div>');
            },
            success: function(data) {
                $('.global-progress').remove();
                $('#manager-dialog-list').find('.'+module_name+'-filters').replaceWith(data.filters);
                $('#manager-dialog-list').find('.'+module_name+'-filters').show();

                var $items = $(data.markup);
                $items.find('img').on('error', module.onImageError);
                $list_container.html($items);
                
                var checked = [];

                if ($('#group-manager-selected').find('input').length) {
                    checked.push($('#group-manager-selected').find('input').val());
                }
                
                $list_container.find('input.selectable-item:checkbox').each(function() {
                    var id = $(this).val();
                    $(this).attr('checked', checked.indexOf(id) != -1);
                });

                $list_container.find('input.selectable-item:checkbox').on('change', function() {
                    var checked = $(this).is(":checked");
                    var caller = $(this).closest('.list-container[data-target="'+module_name+'"]');
                    var all_data = $(this).data();
                        
                    setTimeout(function() {
                        caller.trigger('item-selected', [all_data, checked]);
                    }, 10);
                });

                initForm('#manager-dialog-list .list-container[data-target="'+module_name+'"]');
                initForm('#manager-dialog-list .filters-form');

                Users.after_load_managerList();
            }
        });
    },

    after_load_userList: function() {
        var module_name = this.data.module;
        var module=this;

        $('#users-dialog-list').find('.list-container[data-target="'+module_name+'"]').on('item-selected',function($e,data, is_checked) {

            var selection_container = $(this).closest(".modal-body").data('selectioncontainer');
            var cb = $(this).closest(".modal-body").data('cb');

            if (is_checked === true) {
                if (selection_container != null) {
                    var sm = $(this).closest(".modal-body").data('sm'),
                        selection_name = $(this).closest(".modal-body").data('selectionname'),
                        selection_markup = $(sm).html();
                        
                    for (var i in data) {
                        var counter = 0;

                        while (selection_markup.indexOf('data.'+i) != -1 && counter ++ < 5000) {
                            selection_markup = selection_markup.replace('data.'+i, data[i]);
                        }
                    }

                    var $items = $(selection_markup);

                    $items.find('img').on('error',module.onImageError);

                    if( selection_name.indexOf('[]') == -1 ){
                        // NOT A MULTIPLE SELECTION. CLOSE THE MODAL
                        $(selection_container).html($items);
                        $(this).closest(".vertical-menu").remove();

                    }else if($(selection_container).data('plg') == 'masonry'){
                        $(selection_container).append($items).masonry( 'appended', $items );
                    }else{
                        $(selection_container).append($items);
                    }

                    initForm(selection_container);

                    if (cb != null) {
                        cb();
                    }
                }
            }
            else {
                if(selection_container != null) {
                    var selection_name = $(this).closest(".modal-body").data('selectionname');
                    $(selection_container).find('input:hidden[name="'+selection_name+'"][value="'+data.id+'"]').closest('.selection-item').remove();
                }
            }
        });

        setupGuide('.list-container[data-target="'+module_name+'"]');
    },

    after_load_managerList: function() {
        var module_name = this.data.module;
        var module = this;

        $('#manager-dialog-list').find('.list-container[data-target="'+module_name+'"]').on('item-selected', function($e, data, is_checked) {
            
            var selection_container = $(this).closest(".modal-body").data('selectioncontainer');
            var cb = $(this).closest(".modal-body").data('cb');

            if (is_checked === true) {
                if (selection_container != null) {
                    var sm = $(this).closest(".modal-body").data('sm'),
                        selection_name = $(this).closest(".modal-body").data('selectionname'),
                        selection_markup = $(sm).html();
                        
                    for (var i in data) {
                        var counter = 0;

                        while (selection_markup.indexOf('data.'+i) != -1 && counter ++ < 5000) {
                            selection_markup = selection_markup.replace('data.'+i,data[i]);
                        }
                    }

                    var $items = $(selection_markup);

                    $items.find('img').on('error', module.onImageError);

                    if (selection_name.indexOf('[]') == -1) {
                        // NOT A MULTIPLE SELECTION. CLOSE THE MODAL
                        $(selection_container).html($items);
                        $(this).closest(".vertical-menu").remove();
                    }
                    else if ($(selection_container).data('plg') == 'masonry') {
                        $(selection_container).append($items).masonry( 'appended', $items );
                    }
                    else {
                        $(selection_container).append($items);
                    }

                    initForm(selection_container);

                    if (cb != null) {
                        cb();
                    }
                }
            }
            else {
                if (selection_container != null) {
                    var selection_name = $(this).closest(".modal-body").data('selectionname');
                    $(selection_container).find('input:hidden[name="'+selection_name+'"][value="'+data.id+'"]').closest('.selection-item').remove();
                }
            }
        });

        setupGuide('#group-manager-selected .list-container[data-target="'+module_name+'"]');
    },

    export: function() {
        window.location = 'api/users/export';
    },

    init: function() {
        "use strict";
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function() {
    "use strict";
    Users.init();
});
